export default __webpack_public_path__ + "static/media/hearthWhite.8e95b6a0.svg";